module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title title",
    staticStyle: {
      "color": "#959FA9"
    }
  }, [_vm._v("Inventario ")]), _vm._v(" "), _c('h3', {
    staticClass: "box-title title"
  }, [_c('span', {
    staticClass: "table-btn-icon"
  }), _vm._v(" " + _vm._s('ERI ' + this.accountName + ' - ' + this.periodStr))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-success pull-right exportar",
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("Exportar "), _c('img', {
    attrs: {
      "src": "/static/img/arrow-logo.png"
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-success pull-right",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "to": {
        name: 'InventoryEntry',
        params: {
          accountCode: this.$route.params.accountCode
        }
      },
      "tag": "button"
    }
  }, [_vm._v("Registrar ERI")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box box-success"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('v-eri', {
    attrs: {
      "id": "eriCyclical",
      "title": "ERI Cíclico",
      "unit": "Cant",
      "period": this.period,
      "data": this.eriCyclicalData
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "box box-success"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('v-eri', {
    attrs: {
      "id": "eriLocation",
      "title": "ERI Ubicaciones",
      "unit": "Ubicaciones",
      "period": this.period,
      "data": this.eriLocationData
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "box box-success"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('v-eri', {
    attrs: {
      "id": "eriUnit",
      "title": "ERI Unidades",
      "unit": "Unidades",
      "period": this.period,
      "data": this.eriUnitData
    }
  })], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8b2d54f0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/inventory/InventoryDetail.vue
// module id = 533
// module chunks = 1